import { effect, signal } from "@preact-signals/safe-react";
const KEY = "workloadDriver";
function convertPlantaToForecastDriver(data) {
    if (typeof data !== "object" || data === null) {
        return undefined;
    }
    const driver = data;
    if (typeof driver["name"] !== "string") {
        return undefined;
    }
    return {
        id: driver["name"],
        label: String(driver["workloadDriverLabel"] ?? driver["name"]),
        name: driver["name"],
        subType: driver["workloadDriverSubType"] != null &&
            driver["workloadDriverSubType"] !== ""
            ? String(driver["workloadDriverSubType"])
            : undefined,
        displayName: String(driver["workloadDriverLabel"] ?? driver["name"]),
        displaySubType: driver["workloadDriverSubType"] != null &&
            driver["workloadDriverSubType"] !== ""
            ? String(driver["workloadDriverSubType"])
            : undefined,
        unitOfMeasurement: String(driver["workloadDriverUnit"] ?? ""),
    };
}
function convertForecastToPlantaDriver(driver) {
    return {
        name: driver.name,
        workloadDriverLabel: driver.label,
        workloadDriverSubType: driver.subType ?? null,
        workloadDriverUnit: driver.unitOfMeasurement ?? "",
    };
}
let initialParsed = undefined;
if (typeof window !== "undefined") {
    try {
        const storageValue = localStorage.getItem(KEY);
        if (storageValue !== null && storageValue !== "") {
            const data = JSON.parse(storageValue);
            initialParsed = convertPlantaToForecastDriver(data);
        }
    }
    catch (e) {
        console.warn("Failed to parse workloadDriver from localStorage: %o", e);
    }
}
export const selectedDriver$ = signal(initialParsed);
let isUpdatingFromListener = false;
let isDispatchingEvent = false;
let isInitialized = false;
effect(() => {
    const driver = selectedDriver$.value;
    if (!isInitialized) {
        isInitialized = true;
        return;
    }
    if (isUpdatingFromListener) {
        isUpdatingFromListener = false;
        return;
    }
    try {
        if (driver !== undefined) {
            const plantaFormat = convertForecastToPlantaDriver(driver);
            localStorage.setItem(KEY, JSON.stringify(plantaFormat));
            if (!isDispatchingEvent) {
                isDispatchingEvent = true;
                window.dispatchEvent(new CustomEvent("workloadDriverChanged", {
                    detail: plantaFormat,
                }));
                isDispatchingEvent = false;
            }
        }
        else {
            localStorage.removeItem(KEY);
            if (!isDispatchingEvent) {
                isDispatchingEvent = true;
                window.dispatchEvent(new CustomEvent("workloadDriverChanged", {
                    detail: null,
                }));
                isDispatchingEvent = false;
            }
        }
    }
    catch (error) {
        console.error("Error in driver sync effect:", error);
        isDispatchingEvent = false;
        isUpdatingFromListener = false;
    }
});
function handleDriverChange(newDriver) {
    const converted = convertPlantaToForecastDriver(newDriver);
    if (converted === undefined && selectedDriver$.value === undefined) {
        return;
    }
    isUpdatingFromListener = true;
    selectedDriver$.value = converted;
}
if (typeof window !== "undefined") {
    window.addEventListener("workloadDriverChanged", (event) => {
        if (isDispatchingEvent) {
            return;
        }
        const customEvent = event;
        handleDriverChange(customEvent.detail);
    });
    window.addEventListener("storage", (event) => {
        if (event.key != null && event.key.startsWith("msal.")) {
            return;
        }
        if (event.key === KEY) {
            try {
                if (event.newValue !== null) {
                    const driverData = JSON.parse(event.newValue);
                    handleDriverChange(driverData);
                }
                else {
                    if (selectedDriver$.value !== undefined) {
                        isUpdatingFromListener = true;
                        selectedDriver$.value = undefined;
                    }
                }
            }
            catch (e) {
                console.warn("Failed to parse workloadDriver from storage event", e);
            }
        }
    });
}
//# sourceMappingURL=driverSelect.js.map